const urlParser = document.createElement('a')

export function domain (url) {
  urlParser.href = url
  return urlParser.hostname
}

export function count (arr) {
  return arr.length
}

export function prettyDate (date) {
  var a = new Date(date)
  return a.toDateString()
}

export function dateToString(date) {
    if (date == null || ! (date instanceof Date)) {
        return;
    }

    var year = date.getFullYear();
    var month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
    var day = (date.getDate()) < 10 ? '0' + date.getDate() : date.getDate();

    var dateString = year + "-" + month + "-" + day;
    return dateString;
}

export function stringToDate(DateStr) {

    var converted = Date.parse(DateStr);
    var myDate = new Date(converted);
    if (isNaN(myDate)) {
        var arys = DateStr.split('-');
        myDate = new Date(arys[0], --arys[1], arys[2]);
    }
    return myDate;
}

export function strToDate (formData, fields) {
  
  fields.forEach(function(item, index){
  	if(!(formData[item] instanceof Date)){
  	  formData[item] = new Date(formData[item])
  	}
  })
  // console.log(formData)
  return formData
}


export function pluralize (time, label) {
  if (time === 1) {
    return time + label
  }

  return time + label + 's'
}



// WEBPACK FOOTER //
// ./src/filters/index.js